export default {
  countCityCars: null,
  countOtherCars: null,
  lastPage: null,
  filterCars: null,
  filterParams: null,
  waitForRequestFilterParams: null,
  selectedData: null,
};
